import { SimulationConfig } from '@/domaine/SimulationConfig'

export const configLocationDeMeublé: SimulationConfig = {}
